module.exports = __webpack_public_path__ + "static/media/bike_series.9e865a59.jpg";